import { connectInstructions } from "../../util/redux";
import SentenceInstructionsComponent from "../../components/sentence/instructions";

const SentenceInstructions = connectInstructions(SentenceInstructionsComponent);

export default SentenceInstructions;
